import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

import { splitLang } from '../lib/paths';

/**
 * При переходе на другую страницу показываем её с самого верха.
 *
 * Без этого браузер оставлял прокрутку от прошлой страницы: из корзины
 * покупатель попадал в середину формы заказа и не видел полей контактов.
 *
 * Не трогаем прокрутку, когда:
 * - нажали «Назад»/«Вперёд» — браузер сам вернёт, где человек был;
 * - сменили только язык или фильтр (?category=…) — это та же страница.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const page = splitLang(pathname).rest;

  useLayoutEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return null;
}
